<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        Audios
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field flat hide-details single-line
          label="Search audio title" class="hidden-sm-and-down"
          v-model="filter.search" @input="search"
        ></v-text-field>
      </v-row>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <img src="@/assets/icons/search.svg" alt="">
      </v-btn>
    </v-app-bar>
    <div class="ma-4" id="audio-list">
      <v-simple-table>
        <thead>
          <tr>
            <th>Title</th>
            <th></th>
            <th class="text-left">Author</th>
            <th class="text-left">Category</th>
            <th class="text-left">Status</th>
            <th class="text-left">Date Uploaded</th>
            <th class="text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="audios">
            <tr v-for="audio in audios" :key="audio.id">
              <td class="py-4">
                <v-img
                  :src="getImgUrl(audio.photo)"
                  :lazy-src="getImgUrl(audio.photo)"
                  max-width="120"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </td>
              <td class="py-4">
                <div class="mb-2">{{ audio.title }}</div>
                <div v-if="audio.audio">
                  <audio controls>
                    <source :src="audio.audio.url" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </td>
              <td class="py-4">
                {{ audio.author.full_name }}
              </td>
              <td class="py-4">
                {{ audio.category.label }}
              </td>
              <td class="py-4">
                <span v-if="audio.status == 'uploading'" class="badge badge-blue">{{ audio.status }}</span>
                <span v-if="audio.status == 'processing'" class="badge badge-blue">{{ audio.status }}</span>
                <span v-if="audio.status == 'processing_failed'" class="badge badge-red">{{ audio.status }}</span>
                <span v-if="audio.status == 'ready'" class="badge badge-green">{{ audio.status }}</span>
              </td>
              <td class="py-4">
                {{ audio.uploadedDate }}
              </td>
              <td class="py-4">
                <v-btn class="mx-1" @click="$router.push({name: 'audios.edit', params: {id: audio.id}})" elevation="2" icon>
                  <v-icon>{{ icons.edit }}</v-icon>
                </v-btn>
                <v-btn class="mx-1" @click="removeAudio(audio)" elevation="2" icon>
                  <v-icon>{{ icons.delete }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="7">
              No audios available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <div class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="listMeta.per_page"
        circle
      >
      </v-pagination>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiPencil, mdiMagnify, mdiTrashCan } from '@mdi/js'

export default {
  data () {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        edit: mdiPencil,
        search: mdiMagnify,
        delete: mdiTrashCan
      },
      noImage: require('@/assets/images/no-image.jpeg')
    }
  },

  computed: {
    ...mapState({
      audios: state => state.audio.list,
      listMeta: state => state.audio.listMeta
    })
  },

  methods: {
    ...mapActions({
      getAudios: 'audio/getAudios',
      deleteAudio: 'audio/deleteAudio'
    }),

    ...mapMutations({
      clearAudios: 'audio/clearAudioList'
    }),

    pageChanged (page) {
      this.clearAudios()
      this.fetchAudios(page)
    },

    search: debounce(function () {
      this.clearAudios()
      this.fetchAudios()
    }, 600),

    async fetchAudios (page = 1) {
      if (this.loading) return

      let params = { page }

      if (this.filter.search) {
        params.search = this.filter.search
      }

      this.loading = true
      await this.getAudios(params)
      this.loading = false
    },

    removeAudio (audio) {
      this.$confirm(
        `Are you sure you want to remove <strong>${
          audio.title
        }</strong>?`
      ).then((res) => {
        if (res) {
          this.loading = true
          this.deleteAudio(audio.id)
            .then(async () => {
              this.clearAudios()
              await this.getAudios({ page: parseInt(this.$route.query.page) })
              this.loading = false
            })
        }
      })
    },

    getImgUrl (image) {
      return image ? image.thumb_url : this.noImage
    }
  },

  created () {
    this.clearAudios()
    this.fetchAudios(parseInt(this.$route.query.page))
  },

  watch: {
    'listMeta.current_page' (newVal) {
      this.$router
        .push({
          query: {
            ...this.$route.query,
            page: newVal
          }
        })
        .catch(() => {})
    }
  }
}
</script>
